import { callPromiseSafely } from '../../util/callPromiseSafely';
import TypedNativeModules from '../internal/TypedNativeModules';

export default function close(tag: number): Promise<void | null> {
    return callPromiseSafely(TypedNativeModules.RNCoreNativeModule?.close, tag);
}
